<template id="parent">
  <div>
    <router-view></router-view>
    <!--<page :hide-page.sync = ></page>-->
  </div>
</template>
<script>
//  import page from 'components/page/page.vue';
export default {
    data () {
        return{
        }
    },
    components: {
//      page,

    }
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// App.vue?81f0cbc2